<iframe
  #frame
  class="crm-popup-frame"
  [class.crm-popup-frame--banner]="data.style === 'banner'"
  [class.crm-popup-frame--modal]="data.style === 'modal'"
  [style.height.px]="frameHeight()"
  sandbox="allow-scripts"
  [srcdoc]="srcdoc"
  title="Promotional message"
></iframe>
